import { SupplierProductPayloadSupplier } from '@omnea-app/requests/requestsFrontendClient'
import { EditMode, ProductOptionType, SupplierOptionType } from './types'

export const mapSupplierSelectionToPayload = (
  supplier: Omit<SupplierOptionType, 'products' | 'subsidiaries'>
): SupplierProductPayloadSupplier => {
  const isOrgSupplier = supplier.type === 'SUPPLIER'
  const isActive = isOrgSupplier ? 'state' in supplier && supplier.state === 'ACTIVE' : false

  return { ...supplier, isActive, isOrgSupplier }
}

export const sortOptionsByType = (a: ProductOptionType | SupplierOptionType, b: ProductOptionType | SupplierOptionType) => {
  const typeOrder = ['SUPPLIER', 'GLOBAL_SUPPLIER', 'PRODUCT', 'GLOBAL_PRODUCT', 'CUSTOM_SUPPLIER', 'CUSTOM_PRODUCT']

  const aIndex = typeOrder.indexOf(a.type)
  const bIndex = typeOrder.indexOf(b.type)
  return aIndex - bIndex
}

export const getEditMode = ({
  allowSupplierChange,
  allowProductChange,
  forceReadOnly,
  isDisabled,
  isPrefilledFromRenewal,
}: {
  allowSupplierChange: boolean
  allowProductChange: boolean
  forceReadOnly?: boolean
  isDisabled?: boolean
  isPrefilledFromRenewal?: boolean
}): EditMode => {
  if (forceReadOnly || isDisabled) {
    return {
      supplier: 'read-only',
      product: 'read-only',
      contact: 'read-only',
    }
  }

  const supplierIsEditable = allowSupplierChange && !isPrefilledFromRenewal
  const productIsEditable = allowProductChange

  return {
    supplier: supplierIsEditable ? 'editable' : 'read-only',
    product: productIsEditable ? 'editable' : 'read-only',
    contact: 'editable',
  }
}
